export default "__VITE_ASSET__E8wuXQ_AmxPT2QBGX_$9Vw__"